import { Component, Input, OnInit, inject } from '@angular/core';
import { ClientPrescriberTask } from 'app/core/models/client-prescriber-task.model';
import { TaskFilters } from 'app/core/models/user-settings/task-settings.model';
import { ClientPrescriberTasksService, PagedClientPrescriberTasks } from 'app/core/services/client-prescriber-tasks.service';
import { DatePipe } from '@angular/common';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { TaskEstimatedValueComponent } from '../../../shared/components/task-estimated-value/task-estimated-value.component';
import { ExpirationDateComponent } from '../../../shared/components/expiration-date/expiration-date.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TaskStatusPipe } from '../../../shared/pipes/task-status.pipe';

const defaultRelatedTaskSize = 5;

@Component({
    selector: 'app-client-prescriber-task-related-tasks',
    templateUrl: './client-prescriber-task-related-tasks.component.html',
    styleUrls: ['./client-prescriber-task-related-tasks.component.scss'],
    imports: [RouterLinkActive,
              RouterLink,
              PrescriberNameComponent,
              TaskEstimatedValueComponent,
              ExpirationDateComponent,
              MatProgressSpinner,
              DatePipe,
              TaskStatusPipe]
})
export class ClientPrescriberTaskRelatedTasksComponent implements OnInit {
  private clientPrescriberTasksService = inject(ClientPrescriberTasksService);

  @Input() task: ClientPrescriberTask;

  loadingRelatedTasks = true;
  showingAll = false;

  filters: TaskFilters = new TaskFilters();
  relatedTasks: ClientPrescriberTask[] = [];
  totalRelatedTasks: number;

  ngOnInit() {
    this.init();
  }

  public get showSeeAll() {
    if (this.showingAll) {
      return false;
    } else {
      return this.totalRelatedTasks && this.totalRelatedTasks > (defaultRelatedTaskSize + 1);
    }
  }

  public clickSeeAll($event) {
    $event.preventDefault();
    this.showingAll = true;
    this.loadPatientTasks(this.totalRelatedTasks);
  }

  private init() {
    this.filters.patientId = this.task.patient.id;
    this.loadPatientTasks(defaultRelatedTaskSize + 1);
  }

  private loadPatientTasks(count) {
    const paging = { page: 1, pageSize: count };
    this.clientPrescriberTasksService.getList(paging, this.filters).subscribe(
      (result: PagedClientPrescriberTasks) => {
        this.relatedTasks = this.buildRelatedTasks(result, count);
        this.totalRelatedTasks = result.meta.paging.count;
        this.loadingRelatedTasks = false;
      }
    );
  }

  private buildRelatedTasks(result: PagedClientPrescriberTasks, count: number) {
    const filteredTasks = result.clientPrescriberTasks.filter( (t) => t.id !== this.task.id );
    return filteredTasks.slice(0, count - 1);
  }
}
